// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3z45_","controls":"styles_controls__UFG81","charLimit":"styles_charLimit__5dLJl","input":"styles_input__2_h_P","send":"styles_send__11F2e"};